import { okamiHttpGateway } from '@/lib/axios'
import { CACHE_TIME } from '@/utils/helpers.ts'
import { useQuery } from '@tanstack/react-query'

export async function checkSession() {
  const { data } = await okamiHttpGateway.get<{ isLogged: boolean }>('/auth/v2/check-session')

  return data.isLogged
}

export const getCheckSessionQueryKey = () => ['check-session'] as const

export const getCheckSessionQueryOptions = () => ({
  queryKey: getCheckSessionQueryKey(),
  queryFn: checkSession,
  staleTime: CACHE_TIME.LIVE,
})

export function useCheckSession() {
  return useQuery(getCheckSessionQueryOptions())
}
